/**
 * Подвал главной — в той же раскладке, что подвал astraspace.pro:
 * оператор, документы, контакты. Только на главной: внизу мастера и
 * результатов он мешал бы, особенно в Telegram и VK.
 *
 * Обычные ссылки, без роутера и платформы: подвал должен рисоваться
 * в любом окружении, а документы /privacy и /terms живут вне AppShell.
 */
export function StudioFooter() {
  return (
    <footer className="mt-auto border-t border-border pt-8 text-sm text-text-2">
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
        <div>
          <p className="font-medium text-text">© 2026 АСТРА space</p>
          <p>
            Оператор: Хоменко Марина,
            <br />
            самозанятая, ИНН 860405541270
          </p>
        </div>

        <ul>
          <li>
            <a href="/privacy" className="inline-flex min-h-11 items-center hover:text-text">
              Политика конфиденциальности
            </a>
          </li>
          <li>
            <a href="/terms" className="inline-flex min-h-11 items-center hover:text-text">
              Пользовательское соглашение
            </a>
          </li>
          <li>
            <a href="https://astraspace.pro" target="_blank" rel="noopener" className="inline-flex min-h-11 items-center hover:text-text">
              АСТРА space
            </a>
          </li>
        </ul>

        <div>
          <p className="font-medium text-text">Контакты</p>
          <p className="flex flex-col">
            <a href="mailto:astragoroskop@vk.com" className="inline-flex min-h-11 items-center hover:text-text">
              astragoroskop@vk.com
            </a>
            <a href="https://t.me/astragoroskop" target="_blank" rel="noopener" className="inline-flex min-h-11 items-center hover:text-text">
              Telegram: @astragoroskop
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
